var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Bold/Document"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Document"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Document_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.15917 1.83398H14.8418C17.6733 1.83398 19.25 3.46565 19.25 6.26148V15.7307C19.25 18.5723 17.6733 20.1673 14.8418 20.1673H7.15917C4.3725 20.1673 2.75 18.5723 2.75 15.7307V6.26148C2.75 3.46565 4.3725 1.83398 7.15917 1.83398ZM7.40641 6.10487V6.0957H10.1463C10.5414 6.0957 10.8622 6.41654 10.8622 6.80979C10.8622 7.21404 10.5414 7.53487 10.1463 7.53487H7.40641C7.01132 7.53487 6.69141 7.21404 6.69141 6.81987C6.69141 6.4257 7.01132 6.10487 7.40641 6.10487ZM7.40641 11.679H14.5931C14.9872 11.679 15.3081 11.3581 15.3081 10.964C15.3081 10.5698 14.9872 10.248 14.5931 10.248H7.40641C7.01132 10.248 6.69141 10.5698 6.69141 10.964C6.69141 11.3581 7.01132 11.679 7.40641 11.679ZM7.40688 15.8667H14.5935C14.9593 15.83 15.2352 15.5174 15.2352 15.1517C15.2352 14.7758 14.9593 14.4642 14.5935 14.4275H7.40688C7.13188 14.4 6.86604 14.5283 6.71937 14.7667C6.57271 14.9958 6.57271 15.2983 6.71937 15.5367C6.86604 15.7658 7.13188 15.9033 7.40688 15.8667Z",
    fill: "#B52126"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocument);
export default __webpack_public_path__ + "static/media/icon-document.35ada6e56b796eb8f24337f90c0c384b.svg";
export { ForwardRef as ReactComponent };